export default __webpack_public_path__ + "static/media/loc.7672361f.svg";